import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import cx from "classnames";

import { withStyles, Styles } from "./styles";

interface ContainerProps {
  isLoading: boolean;
}

export const BaseContainer: React.FC<ContainerProps & Styles> = ({
  classes,
  children,
  isLoading
}) => (
  <div className={cx({ [classes.container]: isLoading })}>
    {isLoading && <LinearProgress className={classes.progressBar} />}
    {children}
  </div>
);

export const Container = withStyles(BaseContainer);
